import { Dispatch } from 'redux';
import store from '~/data/store';
import { listRequest } from '~/data/store/reducer/orgUnit/actions/list';

import { iActionList } from '~/domain/interfaces/redux/orgUnit/list';

import { OrgUnitList } from '~/domain/usecases/orgUnit/redux';

export class ReduxOrgUnitList implements OrgUnitList {
  private send: Dispatch;

  constructor() {
    this.send = store.dispatch;
  }

  list = (params: OrgUnitList.Params): iActionList =>
    this.send(listRequest(params));
}
